import { Component, Input, OnInit } from '@angular/core';
import { IBlog, IDashboardMidwifePayload } from 'src/app/models/dashboard.models';

@Component({
  selector: 'app-my-blogs',
  templateUrl: './my-blogs.component.html',
  styleUrls: ['./my-blogs.component.scss']
})
export class MyBlogsComponent implements OnInit {

  @Input() dashboard: IDashboardMidwifePayload;
  blogs: Array<IBlog> = [];

  constructor() { }

  ngOnInit(): void {
    this.blogs = this.dashboard.blogs;
    this.blogs = this.blogs.slice(0,5);
  }

}
